import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, CircularProgress, Checkbox, Pagination } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './resource-assign.css'
import { toast } from 'react-toastify';
import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import CalendarPicker from "../../components/Calendar/CalendarPicker";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from "../../context/AuthContext";

const ManageOvertime = () => {
		const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [deletModal, setDeleteModal] = useState(false)
  const [overtimeList, setOvertimeList] = useState('');
  const [name, setName] = useState('');
  const [reason, setReason] = useState(false)
  const [selectedReason, setselectedReason] = useState([])
  const [shift, setShift] = useState();
  const [isAllDelete, setIsAllDelete] = useState(false);
  const [newDeleteModal, setNewDeleteModal] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 100;

  const columns = [
    {
      field: 'Date', headerName: 'Date', flex: 1, maxWidth: 160,
      valueGetter: (params) => {
        return moment(params?.row?.Shift_Date).format('MM/DD/YY');
      }
    },
    {
      field: 'Name', headerName: 'Name', flex: 1, maxWidth: 200,
      renderCell: (params) => {
        return (params?.row?.orig_emp?.fullName)
      }
    },
    {
      field: 'Shift', headerName: 'Shift', flex: 1, maxWidth: 240,
      renderCell: (params) => {
        return (
					<Chip
						label={params?.row?.shift?.Shift == null ?`Custom (${varFormatTime(`${params?.row?.Start_Time}-${params?.row?.End_Time}`)})` : params?.row?.shift?.Shift}
            className={params?.row?.shift == null ?
              moment(new Date(`2024-12-12 ${params?.row?.Start_Time}`)).format('HH:mm') >= moment(new Date(`2024-12-12 08:00:00`)).format('HH:mm')
                &&
                moment(new Date(`2024-12-12 ${params?.row?.Start_Time}`)).format('HH:mm') <= moment(new Date(`2024-12-12 17:59:59`)).format('HH:mm') ? 'dayChip' : 'nightChip'
              :
              params?.row?.shift?.Shift_Code == 2 ? 'dayChip' : 'nightChip'}
          />
        )
      }
    },
    {
      field: 'Status', headerName: 'Status', flex: 1, maxWidth: 340,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == "O" ?
              <Chip
                label={params?.row?.absent_code == null ? `${params?.row?.Absent_Code} - Open Position` : `${params?.row?.absent_code?.SO_Desc} - ` + "Open Position"}
                className='open-chip' />
              :
              params?.row?.Status == "F" ?
                <Chip
                  label={params?.row?.absent_code == null ? `${params?.row?.Absent_Code} - Filled (${params?.row?.filled_employee?.employee?.fullName})` : `${params?.row?.absent_code?.SO_Desc} - ` + "Filled" + ` (${params?.row?.filled_employee?.employee?.fullName})`}
                  className='filled-chip' />
                :
                params?.row?.Status == "Q" ?
                  <Chip
                    label={params?.row?.absent_code == null ? `${params?.row?.Absent_Code} - Requested` : `${params?.row?.absent_code?.SO_Desc} - ` + "Requested"}
                    className='requested-chip' />
                  :
                  <Chip
                    label={params?.row?.absent_code == null ? `${params?.row?.Absent_Code} - Do Not Fill` : `${params?.row?.absent_code?.SO_Desc} - ` + "Do Not Fill"}
                    className='default-chip' />
            }
          </>
        )
      }
    },
    {
      field: 'action', headerName: 'Action', flex: 1, maxWidth: 130,
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
              onClick={() => {
                if (params?.row?.Status !== 'F') {
                  setNewDeleteModal(true)
                }
                else {
                  setDeleteModal(true)
                }
                setShift({
                  Shift_Date: params?.row?.Shift_Date,
                  Shift_Number: params?.row?.Shift_Number
                })
                setName(params?.row?.orig_emp?.fullName)
              }}
            />

					</Box>
				);
			},
		}
	]

	const getOvertimeList = (loader = true) => {
		const body = {
			'tenure': selectedDate != '' ? moment(selectedDate).format('YYYY-MM') : selectedDate
		}
		if (loader) {
			setLoading(true);
		}
		ApiService.post('/otmanage/list', body)
			.then((data) => {
				const rowsWithIds = data?.data?.map((item, index) => ({
					...item,
					id: index + 1
				})) || [];

				setselectedReason([])
				setOvertimeList(rowsWithIds)
				setLoading(false)
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	let onReasonSelection = (newSelection) => {
		setselectedReason(newSelection)
	}

	const deleteList = () => {
		var temp = []
		temp.push(shift)
		const body = {
			'shift': isAllDelete ? shift : temp,
			'reason': reason == false ? null : reason
		}
		ApiService.post('/otmanage/remove-ots', body)
			.then((data) => {
				setDeleteModal(false)
				setNewDeleteModal(false)
				toast.success(reason == false ? data.message : `${data.message} due to ${reason.toLowerCase()}`)
				setReason(false)
				setIsAllDelete(false)
				getOvertimeList(true)
				setselectedReason([])
			})
			.catch((err) => {
				if (err.status == 422) {
					Object.keys(err.data?.errors).map((er) => {
						return (
							toast.error(err.data?.errors[er][0])
						)
					})
				}
				else {
					toast.error(err?.data?.error)
				}
			})
	}

	useEffect(() => {
		getOvertimeList()
	}, [selectedDate])

	const paginatedRows = overtimeList.slice(
		(page - 1) * rowsPerPage,
		page * rowsPerPage
	);

	const handlePageChange = (event, value) => {
		setPage(value);
	};


  return (
    <>
      {loading ? (
        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
          <CircularProgress />
        </Paper>
      ) : (
        <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
          <Grid container className='align-items-center' gap={1}>
            {/* Heading */}
            <Grid item xs={10} md={'7.5'}>
              <Typography variant="h5">Manage Overtimes</Typography>
            </Grid>

						{/* Delete Button */}
						<Grid item xs={10} md={'auto'}>
							<ButtonTheme type='submit' variant="filled" color='primary' disabled={selectedReason.length <= 1}
								onClick={() => {
									setIsAllDelete(true)
									setDeleteModal(true)
									var tempArr = []
									overtimeList.map((a, i) => {
										if (selectedReason.includes(i + 1)) {
											tempArr.push({
												Shift_Date: a?.Shift_Date,
												Shift_Number: a?.Shift_Number
											})
										}
									})
									setShift(tempArr)
									setName("Multiple Members Selected")
								}}
							>
								Delete
							</ButtonTheme>
						</Grid>

						{/* Month Picker */}
						<Grid item xs={10} md={'auto'} sx={{ "& .MuiBox-root": { marginTop: "0px" } }}>
							<CalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
						</Grid>

					</Grid>

					{(!overtimeList || overtimeList.length == 0) ?
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 595, width: "100%" }}>
							<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
							<span className='mt-4' style={{ color: '#555555' }}>
								No Overtime Found
							</span>
						</div> :
						<>
							<div className='mt-4 hide-header-checkbox-page'>
								<MyTable
									rows={paginatedRows}
									columns={columns}
									checkboxSelection={true}
									hideFooter={true}
									selectedRows={selectedReason}
									onRowSelectionModelChange={onReasonSelection}
								/>
							</div>
							<Pagination
								count={Math.ceil(overtimeList.length / rowsPerPage)}
								page={page}
								onChange={handlePageChange}
								color="primary"
								className="mt-4"
								style={{ display: 'flex', justifyContent: 'end' }}
							/>
						</>
					}
					{/* Delete Modal */}
					<Modal show={deletModal} onHide={() => setDeleteModal(false)}>
						<Modal.Header closeButton>
							<Modal.Title>{name}</Modal.Title>
						</Modal.Header>

						<Modal.Body>
							<div style={{ color: 'black', marginBottom: '10px' }}>
								Please select a reason for deletion from the list below -:
							</div>

							{/* Operational Need / Coverage Change */}
							<Col md={12}>
								<Row>
									<Col md='auto' className='p-0'>
										<Checkbox label={'hr'}
											checked={reason == 'OPERATIONAL' ? true : false} OPERATIONAL
											onClick={() => setReason((val) => val == 'OPERATIONAL' ? '' : 'OPERATIONAL')}

										/>
									</Col>
									<Col md={8} className='p-0'>
										<label className='mt-2'>Operational Need / Coverage Change</label>
									</Col>
								</Row>
							</Col>

							{/* Refusal */}
							<Col md={12}>
								<Row>
									<Col md='auto' className='p-0'>
										<Checkbox label={'hr'}
											checked={reason == 'REFUSAL' ? true : false}
											onClick={() => setReason((val) => val == 'REFUSAL' ? '' : 'REFUSAL')}
										/>
									</Col>
									<Col md={8} className='p-0'>
										<label className='mt-2'>Refusal</label>
									</Col>
								</Row>
							</Col>

							{/* No-Show */}
							<Col md={12}>
								<Row>
									<Col md='auto' className='p-0'>
										<Checkbox label={'hr'}
											checked={reason == 'NOSHOW' ? true : false}
											onClick={() => setReason((val) => val == 'NOSHOW' ? '' : 'NOSHOW')}
										/>
									</Col>
									<Col md={8} className='p-0'>
										<label className='mt-2'>No-Show</label>
									</Col>
								</Row>
							</Col>

							<Row>

								{/* Cancel */}
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
										setDeleteModal(false)
									}}>
										Cancel
									</ButtonTheme>
								</Col>

								{/* Delete */}
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
										onClick={deleteList}
									>
										Delete
									</ButtonTheme>
								</Col>

							</Row>
						</Modal.Body>
					</Modal>

					<Modal show={newDeleteModal} onHide={() => setNewDeleteModal(false)}>
						<Modal.Header closeButton>
							<Modal.Title>Delete</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div style={{ color: '#555555' }}>
								Are you sure to delete ?
							</div>
							<Row>
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setNewDeleteModal(false)}>
										Cancel
									</ButtonTheme>
								</Col>
								<Col md='auto'>
									<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deleteList}>
										Delete
									</ButtonTheme>
								</Col>
							</Row>
						</Modal.Body>
					</Modal>

				</Paper >
			)}
		</>
	)
}

export default ManageOvertime